/**
 * ShieldIcon Component
 * Small shield SVG icon for privacy/security hints.
 * Inherits color from parent via currentColor.
 */

import { designTokens } from '../../constants/designTokens';

interface ShieldIconProps {
  size?: string;
}

export function ShieldIcon({ size = designTokens.components.icon.size.sm }: ShieldIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12 2L4 5.5V11.5C4 16.45 7.4 21.05 12 22C16.6 21.05 20 16.45 20 11.5V5.5L12 2ZM12 11.99H18C17.47 16.11 15.18 19.78 12 20.93V12H6V6.69L12 4.19V11.99Z"
        fill="currentColor"
      />
    </svg>
  );
}
